import { httpsCallable } from 'firebase/functions';
import { ref, uploadBytes } from 'firebase/storage';
import { auth, functions, storage } from '../firebase/config';

const sanitizeFileName = (name) => (
  name
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .replace(/_+/g, '_')
    .slice(0, 120)
);

export const uploadAndScanPrescription = async (file) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Nicht angemeldet.');
  }
  if (!file) {
    throw new Error('Keine Datei ausgewählt.');
  }

  const scanId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const fileName = sanitizeFileName(file.name || 'verordnung');
  const storagePath = `prescriptionScans/${user.uid}/${scanId}-${fileName}`;
  const storageRef = ref(storage, storagePath);

  await uploadBytes(storageRef, file, {
    contentType: file.type || 'application/octet-stream',
    customMetadata: {
      scanId,
      uploadedBy: user.uid,
      originalName: file.name || '',
    },
  });

  const scanMedicalPrescription = httpsCallable(functions, 'scanMedicalPrescription');
  const result = await scanMedicalPrescription({
    scanId,
    storagePath,
    fileName: file.name || fileName,
    contentType: file.type || 'application/octet-stream',
  });

  return result.data;
};
